module.exports = __webpack_public_path__ + "static/img/Wechat - QR CODE.a94d4bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/honggu/Wechat - QR CODE.jpg
// module id = nYFE
// module chunks = 0